<template>
    <div class="fill-height pa-4">
        <v-tabs color="primary accent-4" right>
            <v-tab>English</v-tab>
            <v-tab>Spanish</v-tab>

            <v-tab-item v-for="(term, index) in commercialTerms" :key="index">
                <v-container fluid>
                    <vue-editor
                        :ref="`editor-${index}`"
                        v-if="commercialTerms"
                        @focus="onEditorFocus"
                        @blur="onEditorBlur"
                        :editor-options="editorOptions"
                        v-model="commercialTerms[index].terms"
                        @ready="
                            el => {
                                editors[index] = el
                            }
                        "
                    />
                </v-container>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'SettingsCommercial',
    props: {
        setting: Object,
        commercialTerms: Array,
        pdfImages: Object,
    },
    components: {
        VueEditor,
    },
    computed: {
        ...mapState(['saveBtn']),
    },
    data() {
        return {
            editors: [],
            terms: '',
            editorOptions: {
                modules: {
                    toolbar: [
                        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                        [
                            { align: '' },
                            { align: 'center' },
                            { align: 'right' },
                        ],
                        ['blockquote'],
                        [
                            { list: 'ordered' },
                            { list: 'bullet' },
                            { list: 'check' },
                        ],
                        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
                        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                        ['image'],
                    ],
                    clipboard: {
                        matchVisual: false,
                    },
                    imageResize: {},
                },
            },
            pasteListeners: {},
        }
    },
    watch: {
        editors: {
            handler(newVal) {
                this.$nextTick(() => {
                    newVal.forEach((editor, index) => {
                        this.setupEditorListener(index)
                    })
                })
            },
            deep: true,
        },
    },
    created() {
        if (this.commercialTerms) {
            this.commercialTerms.forEach(x => {
                if (!x.terms) {
                    x.terms = ''
                }
            })
        }
    },
    methods: {
        ...mapActions(['quoteChangesAction']),
        setupEditorListener(index) {
            const editor = this.editors[index]
            if (!editor || !editor.quill) return

            // delete existing paste listeners
            if (this.pasteListeners[index]) {
                editor.quill.root.removeEventListener(
                    'paste',
                    this.pasteListeners[index]
                )
            }

            const pasteHandler = e => {
                this.handlePasteImage(index, e)
            }

            editor.quill.root.addEventListener('paste', pasteHandler)
            this.pasteListeners[index] = pasteHandler

            if (!editor._imgMatcherSet) {
                editor.quill.clipboard.addMatcher('img', node => {
                    const Delta = editor.quill.constructor.import('delta')
                    return new Delta().insert({ image: node.src })
                })
                editor._imgMatcherSet = true
            }
        },

        onEditorFocus() {
            this.quoteChangesAction(false)
        },
        onEditorBlur() {
            this.quoteChangesAction(true)
        },
        handlePasteImage(index, e) {
            const clipboardData = e.clipboardData || window.clipboardData
            if (clipboardData && clipboardData.items) {
                for (let i = 0; i < clipboardData.items.length; i++) {
                    const item = clipboardData.items[i]
                    if (item.type.indexOf('image') !== -1) {
                        e.preventDefault()

                        const file = item.getAsFile()
                        const reader = new FileReader()
                        reader.onload = evt => {
                            const base64Image = evt.target.result
                            if (
                                this.editors[index] &&
                                this.editors[index].quill
                            ) {
                                const quill = this.editors[index].quill
                                const range = quill.getSelection() || {
                                    index: quill.getLength(),
                                }
                                quill.insertEmbed(
                                    range.index,
                                    'image',
                                    base64Image
                                )
                                quill.setSelection(range.index + 1)

                                this.$nextTick(() => {
                                    quill.root
                                        .querySelectorAll('img')
                                        .forEach(img => {
                                            img.style.maxWidth = '100%'
                                            img.style.height = 'auto'
                                        })
                                })
                            }
                        }
                        reader.readAsDataURL(file)
                        return
                    }
                }
            }
        },
    },
}
</script>

<style scoped>
.quillWrapper {
    height: 100%;
}
.quillWrapper >>> .ql-toolbar {
    border: none;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.quillWrapper >>> .ql-container {
    height: calc(100% - 48px);
    border: none;
}
</style>
